import styled, {css} from 'styled-components'
import {PageCardWrapper} from '@/components/ui/page-atoms/PageAtoms'

// Standard settings-page card (same pattern as Referring Specialists):
// grid rows = heading / tabs / scrollable content. Single internal scroll
// container — nested scroll areas previously hid the filter accordions.
export const StyledCardWrapper = styled(PageCardWrapper)(
    () => css`
        overflow-y: hidden;
    `
)

export const StyledTabContent = styled.div`
    overflow-y: auto;
    min-height: 0;
`

export const StyledHeadingTexts = styled.div`
    ${({theme}) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing * 0.5}px;
    `}
`
